export const newConfig = [
  {
    head: "ES_NEW_APPLICATION_PROPERTY_ASSESSMENT",
    body: [
      {
        route: "basic-details",
        component: "BasicDetails",
        key: "data",
        nextStep: "location",
      },
      {
        route: "location",
        component: "LocationDetails",
        nextStep: "plot-details",
        hideInEmployee: true,
        key: "address",
        texts: {
          headerCaption: "BPA_STEPPER_SCRUTINY_DETAILS_HEADER",
          header: "BPA_NEW_TRADE_DETAILS_HEADER_DETAILS",
          cardText: "",
          submitBarLabel: "CS_COMMON_NEXT",
          skipAndContinueText: "CORE_COMMON_SKIP_CONTINUE",
        },
      },
      {
        route: "plot-details",
        component: "PlotDetails",
        key: "data",
        nextStep: "scrutiny-details",
        texts: {
          headerCaption: "BPA_SCRUTINY_DETAILS",
          header: "BPA_PLOT_DETAILS_TITLE",
          cardText: "",
          submitBarLabel: "CS_COMMON_NEXT",
          skipText: "CORE_COMMON_SKIP_CONTINUE",
        }
      },
      {
        route: "scrutiny-details",
        component: "ScrutinyDetails",
        nextStep: "private-professional-information",
        hideInEmployee: true,
        key: "subOccupancy",
        texts: {
          headerCaption: "BPA_STEPPER_SCRUTINY_DETAILS_HEADER",
          header: "BPA_STEPPER_SCRUTINY_DETAILS_HEADER",
          cardText: "",
          submitBarLabel: "CS_COMMON_NEXT",
          skipText:"CORE_COMMON_SKIP_CONTINUE",
        },
      },
      
      {
        route: "private-professional-information",
        component: "ProfessionalDetails",
        nextStep: "owner-details",
        hideInEmployee: true,
        key: "professional-information",
        texts: {
          headerCaption: "BPA_PRIVATE_PROFESSIONAL_HEADER",
          header: "BPA_PROFESSIONAL_DETAILS",
          cardText: "",
          submitBarLabel: "CS_COMMON_NEXT",
          skipAndContinueText: "CORE_COMMON_SKIP_CONTINUE",
        },
      },
      {
        route: "owner-details",
        component: "OwnerDetails",
        nextStep: "document-details",
        key: "owners",
        texts: {
          headerCaption: "BPA_OWNER_AND_DOCUMENT_DETAILS_LABEL",
          header: "BPA_APPLICANT_DETAILS_HEADER",
          submitBarLabel: "CS_COMMON_NEXT"
        }
      },
      {
        route: "document-details",
        component: "DocumentDetails",
        nextStep: null,
        key: "documents",
        texts: {
          headerCaption: "BPA_OWNER_AND_DOCUMENT_DETAILS_LABEL",
          header: "BPA_DOCUMENT_DETAILS_LABEL",
          submitBarLabel: "CS_COMMON_NEXT",
        }
      },
    ]
  }
]